Vue.component('rating-metrics', require('./RatingMetrics').default);
Vue.component('sites-metrics', require('./SitesMetrics').default);
Vue.component('bar-metrics', require('./BarMetrics').default);
Vue.component('count-metric', require('./CountMetric').default);
Vue.component('percent-metric', require('./PercentMetric').default);
Vue.component('nps-response-metrics', require('./NpsResponseMetrics').default);
Vue.component('trending-over-time', require('./TrendingOverTime').default);
Vue.component('trending-over-time-interval', require('./TrendingOverTimeInterval').default);
